import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useUrlState<TKey extends string>(
  keys: ReadonlyArray<TKey>
): {
  values: Readonly<Record<TKey, string | undefined>>;
  set: (patch: Partial<Record<TKey, string | undefined>>) => void;
} {
  const [params, setParams] = useSearchParams();

  const values = {} as Record<TKey, string | undefined>;
  for (const k of keys) {
    const v = params.get(k);
    values[k] = v === null ? undefined : v;
  }

  const set = useCallback(
    (patch: Partial<Record<TKey, string | undefined>>) => {
      setParams((prev) => {
        const next = new URLSearchParams(prev);
        for (const [k, v] of Object.entries(patch)) {
          if (v === undefined || v === '') next.delete(k);
          else next.set(k, String(v));
        }
        return next;
      });
    },
    [setParams]
  );

  return { values, set };
}
